var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LinkedinIcon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "FAcebook"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounds",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.080718,4 L6.050531,4 C4.95649769,4 4,4.78770398 4,5.86923405 L4,25.9431824 C4,27.030964 4.95649769,27.999965 6.050531,27.999965 L26.0744664,27.999965 C27.1747513,27.999965 28,27.0247124 28,25.9431824 L28,5.86923405 C28.0062166,4.78770398 27.1747513,4 26.080718,4 Z M11.4394265,24.0051805 L8.0010361,24.0051805 L8.0010361,13.3149122 L11.4394265,13.3149122 L11.4394265,24.0051805 Z M9.83901206,11.6894913 L9.81400558,11.6894913 C8.71372066,11.6894913 8.0010361,10.8705292 8.0010361,9.84526368 C8.0010361,8.80124332 8.73247551,8.0010361 9.85776691,8.0010361 C10.9830583,8.0010361 11.6707364,8.7949917 11.6957429,9.84526368 C11.6957429,10.8705292 10.9830583,11.6894913 9.83901206,11.6894913 Z M24.0051805,24.0051805 L20.5667901,24.0051805 L20.5667901,18.1599168 C20.5667901,16.7595542 20.0666606,15.8030565 18.8225884,15.8030565 C17.8723424,15.8030565 17.3096967,16.4469732 17.0596319,17.0721351 C16.9658576,17.2971934 16.9408511,17.6035227 16.9408511,17.9161037 L16.9408511,24.0051805 L13.5024607,24.0051805 L13.5024607,13.3149122 L16.9408511,13.3149122 L16.9408511,14.8027975 C17.4409806,14.0901129 18.222433,13.0648474 20.0416541,13.0648474 C22.2984885,13.0648474 24.0051805,14.5527327 24.0051805,17.7598132 L24.0051805,24.0051805 L24.0051805,24.0051805 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.d4090b091f962a42867adb2f4636f916.svg";
export { ForwardRef as ReactComponent };